import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01c0f7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "landing-federations"
}
const _hoisted_2 = { class: "w-md-75 w-lg-50 text-center mx-md-auto mb-7" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "img-fluid",
  style: {"width":"72px","height":"82px"},
  src: "https://htmlstream.com/preview/front-v4.3.1/assets/img/160x160/img1.jpg"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi-chevron-right ms-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!
  const _component_MrUiKitList = _resolveComponent("MrUiKitList")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_InfiniteScroll, {
          guard: _ctx.guard,
          containerClasses: ['container'],
          rowClasses: ['d-flex'],
          isLoading: _ctx.isLoading,
          onLoad: _ctx.loadMore
        }, {
          title: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.t('home.federations.title')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_MrUiKitList, {
              classes: ['p-2', 'mb-4'],
              columns: 4,
              items: _ctx.federations
            }, {
              default: _withCtx(({ item }) => [
                _createVNode(_component_MrUiKitCard, {
                  classes: ['h-100', 'federation-card'],
                  bodyClasses: ['pt-0', 'pb-0']
                }, {
                  header: _withCtx(() => [
                    (item.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "img-fluid",
                          style: {"max-height":"82px","width":"auto"},
                          src: item.logo.url
                        }, null, 8, _hoisted_3))
                      : (_openBlock(), _createElementBlock("img", _hoisted_4))
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "card-link text-primary link-navigate",
                      onClick: () => _ctx.onClick(item)
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.t('home.federations.goTo')) + " ", 1),
                      _hoisted_7
                    ], 8, _hoisted_6)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("h3", {
                      class: "card-title justify-content-between link-navigate",
                      style: {"font-size":"18px"},
                      onClick: () => _ctx.onClick(item)
                    }, _toDisplayString(item.fullname), 9, _hoisted_5)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          _: 1
        }, 8, ["guard", "isLoading", "onLoad"])
      ]))
    : _createCommentVNode("", true)
}